export const ASSET_SERVER_BASE_URL = 'https://assets.rpglogs.com';
export const ASSET_SERVER_ALTERNATIVE_BASE_URL = 'https://assets2.rpglogs.com';
export const ASSET_SERVER_S3_BASE_URL =
  'https://combatlogassets.s3.us-west-2.amazonaws.com';
